import axios from 'axios';

// const configLocal = localStorage.getItem('configColetor');
// const baseURL = configLocal ? JSON.parse(configLocal).host : '';

// Adicionado para fins de testes pois a API do Syclus não está aceitando HTTPS
// e isso faz as requisições falharem baseURL: 'https://coletor-syclus.netlify.app/api'
const apiNoHeaders = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API
});

export default apiNoHeaders;